import { render } from "./FormTest.vue?vue&type=template&id=6e5fddf5&scoped=true"
import script from "./FormTest.vue?vue&type=script&lang=js"
export * from "./FormTest.vue?vue&type=script&lang=js"

import "./FormTest.vue?vue&type=style&index=0&id=6e5fddf5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6e5fddf5"

export default script